import { setState, getBookmarkList } from '../core';

export const loadMore = async () => {
  setState({ status: 'loading' });
  const lastTeaserNumber = document.querySelectorAll(
    '.list-bookmarks .bookmark-teaser'
  ).length;
  const bookmarkList = await getBookmarkList(lastTeaserNumber);
  setState({
    bookmarkList: bookmarkList.bookmarks,
    listHasMoreTeasers: bookmarkList.hasMoreTeasers,
    status: 'idle',
  });
};
